/* eslint-disable react/no-unescaped-entities */
import { useRef } from 'react';
import {
	Grid,
	Card,
	CardContent,
	IconButton,
	useMediaQuery,
	Divider,
	Button,
	Typography,
	Box,
	List,
	Avatar,
	ImageList,
	ImageListItem,
	ListItem,
	ListItemText,
	ListItemAvatar,
	CardActions,
	ToggleButtonGroup,
	ToggleButton,
	Skeleton,
	TextField,
	Checkbox,
	CircularProgress,
	FormHelperText,
	FormHelperTextProps,
	FormGroup,
	FormControlLabel,
	FormControl,
	OutlinedInput,
	InputAdornment,
	LinearProgress,
	MenuItem,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { ImageLoader } from '~/content/components/ImageLoader';
import conclution from '~/content/images/references/stk-website/conclution2.webp';

const Conclusion = (): JSX.Element => {
	const conclution_pic = useRef(null);
	let { t } = useTranslation(['project_stk-website']);
	const theme = useTheme();
	const isXs = useMediaQuery(theme.breakpoints.up('xs'), {
		defaultMatches: true,
	});
	const isSm = useMediaQuery(theme.breakpoints.up('sm'), {
		defaultMatches: true,
	});
	const isMd = useMediaQuery(theme.breakpoints.up('md'), {
		defaultMatches: true,
	});
	const isLg = useMediaQuery(theme.breakpoints.up('lg'), {
		defaultMatches: true,
	});
	// console.log({ isMd });
	//?  md: 900
	//?  lg: 1200
	//?  xl: 1536

	const containerAnimation = {
		hidden: { opacity: 0 },
		show: {
			opacity: 1,
			// transition: {
			//   staggerChildren: 0.15,
			//   ease: 'easeIn',
			// },
		},
	};

	const itemAnimation = {
		hidden: { opacity: 0 },
		show: {
			opacity: 1,
			transition: {
				duration: 0.3,
				ease: 'linear',
			},
		},
	};

	return (
		<Grid container spacing={4}>
			<Grid item container spacing={4} justifyContent='space-between'>
				<Grid item container xs={12} md={5} alignItems={'top'}>
					<Box>
						<Typography variant='h5' component='h3' gutterBottom sx={{ fontWeight: 700 }}>
							{t('conclusion_headline')}
						</Typography>

						<Typography variant='body1' component='p' color='text.secondary'>
							{t('conclusion_text')}
						</Typography>
					</Box>
				</Grid>
				<Grid
					item
					container
					xs={12}
					md={6}
					alignItems={isMd ? 'center' : 'flex-start'}
					justifyContent={isMd ? 'center' : 'flex-start'}
				>
					<Box>
						<Typography
							component='p'
							variant='caption'
							color='text.secondary'
							fontWeight='bold'
							mb={1}
						>
							{t('conclusion_caption')}
						</Typography>
						<ImageLoader
							delay={true}
							intersectViewportCheck={true}
							childRef={conclution_pic}
							enlargeOnClick={true}
						>
							<Box
								ref={conclution_pic}
								// data-aos={isMd ? 'fade-up' : 'fade-up'}
								// component={LazyLoadImage}
								// effect="blur"
								component={'img'}
								src={conclution}
								alt='Gruppenbild mit Beamten der Staatskanzlei Bayern als Softwaredienstleister'
								mt={0}
								sx={{
									width: '100%',
									// minWidth: 370,
									// maxWidth: 480,

									objectFit: 'contain',
									filter: theme.palette.mode === 'dark' ? 'brightness(0.9)' : 'none',
								}}
							/>
						</ImageLoader>
					</Box>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default Conclusion;
